module.exports = __webpack_public_path__ + "static/media/anton-dog.9f4bcb85.jpg";